module.exports = __webpack_public_path__ + "static/img/pc_hd_activity3_content1_img.55f6606.png";